export default __webpack_public_path__ + "static/media/send.dcdb90d6.gif";